export async function initCookieNotice(): Promise<void> {
  const container = document.getElementById('cookie_notice_app')
  if (!container || container.dataset.mounted) {
    return
  }

  container.dataset.mounted = 'true'
  try {
    const [{ createApp }, { default: CookieNotice }] = await Promise.all([
      import('vue'),
      import('./CookieNotice.vue')
    ])
    createApp(CookieNotice).mount(container)
  } catch (error: unknown) {
    delete container.dataset.mounted
    console.error('Не удалось загрузить уведомление о cookies:', error)
  }
}
